

import __layout_0 from '/D:/laragon/www/kwc-beta/resources/js/layouts/default.vue'
export const layouts = {
'blank': () => import('/D:/laragon/www/kwc-beta/resources/js/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/D:/laragon/www/kwc-beta/resources/js/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/D:/laragon/www/kwc-beta/resources/js/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/D:/laragon/www/kwc-beta/resources/js/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/D:/laragon/www/kwc-beta/resources/js/layouts/components/NavBarNotifications.vue'),
'components/NavbarShortcuts': () => import('/D:/laragon/www/kwc-beta/resources/js/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/D:/laragon/www/kwc-beta/resources/js/layouts/components/NavbarThemeSwitcher.vue'),
'components/NavSearchBar': () => import('/D:/laragon/www/kwc-beta/resources/js/layouts/components/NavSearchBar.vue'),
'components/UserProfile': () => import('/D:/laragon/www/kwc-beta/resources/js/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
